import axios from 'axios';

const getSalesdeskVersion = () => axios.get('https://salesdesk.yalochat.com/version.json');

export default getSalesdeskVersion;
